export default {
  data() {
    return {
      coinbaseBal: [],
    };
  },
  methods: {
    getCoinbaseBal() {
      const url = "api/v1/coinbase/fiatBalance";
      return this.$http
        .get(url)
        .then((response) => {
          this.coinbaseBal = response;
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        });
    },
  },
};
